// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ncpiegraph {
  width: 95% !important;
  height: 188px !important;

  /* width: 100% !important; */
  /* height: 100% !important; */

  margin: auto;
  position: relative;
  top : 5px;
  /* bottom: 32px; */
}

.ncstackbargraph {
  height: 200px !important;
  width: 86% !important;
  margin: auto;
}

.ncageanalysisgraph {
     height: 195px !important;
  width: 340px !important;
  /* margin: auto; */
  margin-left: 10px;
}

.graphBox {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/NcGraphs/ncGraphStyles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,wBAAwB;;EAExB,4BAA4B;EAC5B,6BAA6B;;EAE7B,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;AACd;;AAEA;KACK,wBAAwB;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".ncpiegraph {\r\n  width: 95% !important;\r\n  height: 188px !important;\r\n\r\n  /* width: 100% !important; */\r\n  /* height: 100% !important; */\r\n\r\n  margin: auto;\r\n  position: relative;\r\n  top : 5px;\r\n  /* bottom: 32px; */\r\n}\r\n\r\n.ncstackbargraph {\r\n  height: 200px !important;\r\n  width: 86% !important;\r\n  margin: auto;\r\n}\r\n\r\n.ncageanalysisgraph {\r\n     height: 195px !important;\r\n  width: 340px !important;\r\n  /* margin: auto; */\r\n  margin-left: 10px;\r\n}\r\n\r\n.graphBox {\r\n  width: 100%;\r\n  height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
